var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiskCase2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1704_3338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 30,
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1704_3338",
    x: 0.151122,
    y: 0.151122,
    width: 126.52,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1704_3338"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1704_3338"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1704_3338",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1704_3338",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1704_3338",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskCase2);
export default __webpack_public_path__ + "static/media/RiskCase2.c3325578047338322998161116111da9.svg";
export { ForwardRef as ReactComponent };